import CompanionLearnMore from "../../Family/LearnMore/CompanionLearnMore";
import CrisisPlanningLearnMore from "../../Family/LearnMore/CrisisPlanningLearnMore";
import FamilyMeetingLearnMore from "../../Family/LearnMore/FamilyMeetingLearnMore";
import HomeSafetyLearnMore from "../../Family/LearnMore/HomeSafetyLearnMore";
import ComingSoonPlaceholder from "../../../../Assessment/ComingSoonPlaceholder";
import UsingTechnologyLearnMore from "../../Family/LearnMore/UsingTechnologyLearnMore";
import ChoosingCaregiversLearnMore from "../../Family/LearnMore/ChoosingCaregiversLearnMore";
import GrandparentRelationshipsLearnMore from "../../Family/LearnMore/GrandparentRelationshipsLearnMore";
import CaringForYourselfLearnMore from "../../Family/LearnMore/CaringForYourselfLearnMore";
import HomeMaintenanceLearnMore from "../../Family/LearnMore/HomeMaintenanceLearnMore";
import WidowhoodSupportLearnMore from "../../Family/LearnMore/WidowhoodSupportLearnMore";

export interface FamilyLearnMoreFactoryProps {
  infoSlideIndex: number;
}

export const FamilyLearnMoreFactory: React.FC<FamilyLearnMoreFactoryProps> = ({
  infoSlideIndex
}) => {
  switch (infoSlideIndex) {
    case 0: {
      return (
        <FamilyMeetingLearnMore />
      );
    }
    case 1: {
      return (
        <CompanionLearnMore />
      );
    }
    case 2: {
      return (
        <CrisisPlanningLearnMore />
      );
    }
    case 3: {
      return (
        <HomeSafetyLearnMore />
      );
    }
    case 4: {
      return (
        <UsingTechnologyLearnMore />
      );
    }
    case 5: {
      return (
        <ChoosingCaregiversLearnMore />
      );
    }
    case 6: {
      return (
        <GrandparentRelationshipsLearnMore />
      );
    }
    case 7: {
      return (
        <CaringForYourselfLearnMore />
      );
    }
    case 8: {
      return (
        <HomeMaintenanceLearnMore />
      );
    }
    case 9: {
      return (
        <WidowhoodSupportLearnMore />
      );
    }
    default: {
      return (
        <ComingSoonPlaceholder />
      );
    }
  }
};
